export const drivers = [
  {
    "Driver Name": "CDX1-1070",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "25mm/1in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "PETP film",
    "Continuous Power Rating": "24W",
    Sensitivity: "106dB",
  },
  {
    "Driver Name": "CDX1-1010",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "25mm/1in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "PETP film",
    "Continuous Power Rating": "30W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "CDX1-1445",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "35mm/1.4in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "PETP film",
    "Continuous Power Rating": "40W",
    Sensitivity: "106dB",
  },
  {
    "Driver Name": "CDX1-1446",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "35mm/1.4in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "PETP film",
    "Continuous Power Rating": "40W",
    Sensitivity: "106dB",
  },
  {
    "Driver Name": "CDX1-1440",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "35mm/1.4in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Titanium",
    "Continuous Power Rating": "50W",
    Sensitivity: "106dB",
  },
  {
    "Driver Name": "CDX1-1447",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "35mm/1.4in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Polyimide",
    "Continuous Power Rating": "70W",
    Sensitivity: "106dB",
  },
  {
    "Driver Name": "CDX1-1742",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Polyimide",
    "Continuous Power Rating": "100W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "CDV1-1757",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Polyimide",
    "Continuous Power Rating": "120W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "CDX1-1740",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Titanium",
    "Continuous Power Rating": "100W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "CDX1-1745",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "PETP film",
    "Continuous Power Rating": "80W",
    Sensitivity: "110dB",
  },
  {
    "Driver Name": "CDX1-1746",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "PETP film",
    "Continuous Power Rating": "80W",
    Sensitivity: "110dB",
  },
  {
    "Driver Name": "CDX1-1747",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Polyimide",
    "Continuous Power Rating": "120W",
    Sensitivity: "110dB",
  },
  {
    "Driver Name": "CDX1-1748",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Polyimide",
    "Continuous Power Rating": "120W",
    Sensitivity: "110dB",
  },
  {
    "Driver Name": "CDX1-1415",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "35mm/1.4in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Aluminium",
    "Continuous Power Rating": "40W",
    Sensitivity: "104dB",
  },
  {
    "Driver Name": "CDX1-1425",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "35mm/1.4in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Aluminium",
    "Continuous Power Rating": "50W",
    Sensitivity: "108dB",
  },
  {
    "Driver Name": "CDX1-1430",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "35mm/1.4in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Aluminium",
    "Continuous Power Rating": "100W",
    Sensitivity: "108dB",
  },
  {
    "Driver Name": "CDX1-1720",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Titanium",
    "Continuous Power Rating": "100W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "CDX1-1730",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "PETP film",
    "Continuous Power Rating": "80W",
    Sensitivity: "110dB",
  },
  {
    "Driver Name": "CDX1-1731",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "PETP film",
    "Continuous Power Rating": "80W",
    Sensitivity: "110dB",
  },
  {
    "Driver Name": "CDX1-1732",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "44mm/1.75in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Polyimide",
    "Continuous Power Rating": "100W",
    Sensitivity: "110dB",
  },
  {
    "Driver Name": "CDX14-3030",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "75mm/3in",
    "Throat Exit": "36mm/1.4in",
    "Diaphragm Material": "Titanium",
    "Continuous Power Rating": "150W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "CDX1-1412",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "35mm/1.4in",
    "Throat Exit": "25mm/1.0in",
    "Diaphragm Material": "Polyimide",
    "Continuous Power Rating": "35W",
    Sensitivity: "106dB",
  },
  {
    "Driver Name": "CDX14-3040",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "75mm/3in",
    "Throat Exit": "36mm/1.4in",
    "Diaphragm Material": "Polyimide",
    "Continuous Power Rating": "150W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "CDX14-3050",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "75mm/3in",
    "Throat Exit": "36mm/1.4in",
    "Diaphragm Material": "Titanium",
    "Continuous Power Rating": "150W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "CDX14-2410",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "60mm/2.4in",
    "Throat Exit": "36mm/1.4in",
    "Diaphragm Material": "Titanium",
    "Continuous Power Rating": "100W",
    Sensitivity: "106dB",
  },
  {
    "Driver Name": "CDX14-2420",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "60mm/2.4in",
    "Throat Exit": "36mm/1.4in",
    "Diaphragm Material": "Titanium",
    "Continuous Power Rating": "140W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "CDX20-3020",
    "Magnet Type": "Ferrite",
    "Voice Coil Size": "75mm/3in",
    "Throat Exit": "51mm/2.0in",
    "Diaphragm Material": "Titanium",
    "Continuous Power Rating": "200W",
    Sensitivity: "107dB",
  },
  {
    "Driver Name": "AXI2050",
    "Magnet Type": "Neodymium",
    "Voice Coil Size": "125mm/5in",
    "Throat Exit": "51mm/2.0in",
    "Diaphragm Material": "Titanium",
    "Continuous Power Rating": "300W",
    Sensitivity: "108dB",
  },
];
